import { render, staticRenderFns } from "./PersonalReturns.vue?vue&type=template&id=582dc2a8&scoped=true"
import script from "./PersonalReturns.vue?vue&type=script&lang=ts"
export * from "./PersonalReturns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582dc2a8",
  null
  
)

export default component.exports